$(".flexslider").flexslider({
  animation: "fade",
  touch: true,
  useCSS: false,
  controlNav: true,
  directionNav: true,
  slideshow: true,
  slideshowSpeed: 15000,
});

$(".flexslider .slide-prev").click(function (event) {
  event.preventDefault();
  $(event.target).closest(".flexslider").flexslider("prev");
});
$(".flexslider .slide-next").click(function (event) {
  event.preventDefault();
  $(event.target).closest(".flexslider").flexslider("next");
});
$(".video-text-bg").on("click", function () {
  $(this).toggleClass("active");
});

$(".navbar-nav, .nav-link, .social-nav-item, .submenu-item").on(
  "click",
  function () {
    $(".navbar-collapse").removeClass("show");
  }
);

var scrollStart = function () {
  window.scrollTo(0, 0);
};
if ($(".arrows-back")) {
  $(".go-back p").on("click", scrollStart);
}

var player = document.getElementById("player");
let progress = document.getElementById("progress");
let playbtn = document.getElementById("playbtn");
let control = document.getElementById("control");
let pause = document.getElementById("pause");
let length = document.getElementById("length");

var playpause = function () {
  if (player.paused) {
    player.play();
    $("#playbtn").addClass("d-none");
    $("#pause").toggleClass("d-none");
  } else {
    player.pause();
    $("#playbtn").removeClass("d-none");
    $("#pause").addClass("d-none");
  }
};
if (control) control.addEventListener("click", playpause);
if (player) {
  player.ontimeupdate = function () {
    let ct = player.currentTime;
    current.innerHTML = timeFormat(ct);
    //progress
    let duration = player.duration;
    prog = Math.floor((ct * 100) / duration);
    progress.style.setProperty("--progress", prog + "%");
  };
  $(document).ready(function () {
    //   length.innerHTML = player.duration;
    dur = player.duration;
    minutes = Math.floor(player.duration / 60);
    seconds = Math.floor(player.duration % 60);
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (isNaN(seconds) || isNaN(minutes)) {
      return (length.innerHTML = "00:00");
    } else {
      return (length.innerHTML = minutes + ":" + seconds);
    }
  });
}

// const scrollToTop = () => {
//   $("#modal-content").scrollTop(0);
// };
// $(".go-back").on("click", scrollToTop);
function timeFormat(ct) {
  minutes = Math.floor(ct / 60);
  seconds = Math.floor(ct % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return minutes + ":" + seconds;
}

$(".filters").niceScroll({
  cursorwidth: "5px",
  autohidemode: false,
  horizrailenabled: false,
});

var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});
$(window).on("resize scroll", function () {
  $(".arrows-container div").each(function (index) {
    if ($(this).isInViewport() && !$(this).hasClass("visible")) {
      $(this).addClass("visible");
      $(this).paroller({
        factor: 0.05,
        type: "foreground",
      });
    }
  });
});

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// CREATE VIDEOS "CLASS" to handler videos
var Videos = (function () {
  // VARIABLES
  var $ = jQuery, // The jquery
    players = [], // players array (to coltrol players individually)
    queue = []; // videos queue (once api is ready, transform this into YT player)

  // Constructor
  function Videos() {}

  // METHODS
  // Add elements to queue
  Videos.prototype.add = function ($video) {
    queue.push($video);
  };

  // Load YT API
  Videos.prototype.loadApi = function () {
    // jQuery get script
    $.getScript("//www.youtube.com/iframe_api", function () {
      // once loaded, create the onYouTubeIframeAPIReady function
      window.onYouTubeIframeAPIReady = function () {
        queue.forEach(function ($video) {
          // Create the YT player
          var player = new YT.Player($video.get(0), {
            width: "100%",
            height: "100%",
            playerVars: {
              allowfullscreen: 1,
              controls: 0,
              rel: 0,
              showinfo: 0,
              ecver: 2,
            },
            videoId: $video.data("id"),
            events: {
              onStateChange: onPlayerStateChange,
            },
          });
          // add to players array
          players.push(player);
        });
      };
      window.onPlayerStateChange = function (event) {
        if (event.data == 2) {
          var parent = event.target.getIframe().parentNode;
          links = parent.getElementsByTagName("div");
          links[0].classList.remove("active");
        } else {
          var parent = event.target.getIframe().parentNode;
          links = parent.getElementsByTagName("div");
          links[0].className = links[0].className + " " + "active";
        }
      };
    });
  };

  return Videos;
})();

var navItems = 0;
var freeSpace = 0;
var containerWidth = 0;
var navPaddings = function () {
  if ($(window).width() > 1200) {
    containerWidth = parseInt($(".nav-wrapper").css("width"));
   
    $(".nav-wrapper .nav-item").each(function () {
      $(this).css("padding-right", 0 + "px");
      $(this).css("padding-left", 0 + "px");
      containerWidth -= parseInt($(this).css("width"));
      console.log(containerWidth);
      navItems++;
    });
    freeSpace = containerWidth / ((navItems * 2) - 2) ;
    var i = 0;
    $(".nav-wrapper .nav-item").each(function () {
      if (i == 0) {
        $(this).css("padding-right", freeSpace + "px");
      } else if (i < navItems - 1 && i > 0) {
        $(this).css("padding-right", freeSpace + "px");
        $(this).css("padding-left", freeSpace + "px");
      } else {
        $(this).css("padding-left", freeSpace + "px");
      }
      i++;
    });
    containerWidth = 0;
  }
  freeSpace = 0;
  i = 0;
  
  navItems = 0;
};
$(document).ready(navPaddings);

var previousWindowWidth = $(window).width();

var checkWidth = function () {
  var currentWindowWidth = $(window).width();
  if (previousWindowWidth > 1400 && currentWindowWidth < 1400) {
    navPaddings();
  } else if (previousWindowWidth < 1400 && currentWindowWidth > 1400) {
    navPaddings();
  }
  previousWindowWidth = currentWindowWidth;
};
$(window).resize(checkWidth);
$(".nav-wrapper .nav-item").on("click", function(){
  $(".nav-wrapper .nav-item").removeClass('active');
  $(this).addClass("active");
});
var videos = new Videos();
$(".video").each(function () {
  videos.add($(this));
});
videos.loadApi();

let interval;
jQuery(document).ready(function () {
  interval = setInterval(facebookWidget, 500);
});

function facebookWidget() {
  if ($(".fb_dialog_content").is(":visible")) {
    setTimeout(() => {
      $("#fb-root").addClass("active");
      $(".fb-shadow").addClass("active");
      clearInterval(interval);
    }, 1000);
  }
}
let shadowInterval;
jQuery(document).ready(function () {
  shadowInterval = setInterval(hideShadow, 500);
});

function hideShadow() {
  if ($(".fb_customer_chat_bounce_in_from_left").is(":visible")) {
    $(".fb-shadow").addClass("hidden");
  } else {
    setTimeout(() => {
      $(".fb-shadow").removeClass("hidden");
    }, 1000);
  }
}

if ($("section").hasClass("in-numbers")) {
  window.addEventListener("scroll", function () {
    var element = document.querySelector(".in-numbers");
    var position = element.getBoundingClientRect();
    let sectionHeight = $(".in-numbers").height() / -1.6;

    if (position.top - window.innerHeight <= sectionHeight) {
      $(".numbers-item").addClass("active");
    }
  });
}
